import React from 'react'
import { status_aktif } from '../../constants/general'
import Dropzone from 'react-dropzone'
import axios from '../../axios';
import FormDropdown from '../../components/FormDropdown'
import DatePicker from 'react-datepicker'
import { FOTO_SISWA_HOST } from '../../constants/siteConfig'
import { FOTO_WALI_HOST } from '../../constants/siteConfig'

const jekel = [
	{key: "l", value: "Laki-laki"},
	{key: "p", value: "Perempuan"},
]

const selectForm = [
	{ key: "buka", value: "Tampilkan Form Wali" },
	{ key: "tutup", value: "Sembunyikan Form Wali" }
]

class FormsSiswa extends React.Component {

	constructor() {
		super()

		this.state = {
			dataKelas: [],
			dataWali : [],
		}
	}

	loadDataKelas() {

		axios.post("/kelas")
			.then(response => {

				return response.data.data.map(item => ({
					key: item.kelas_id,
					value: item.kelas_nama
				}))
			})
			.then(result => {

				this.setState({
					dataKelas: result
				})
			})
			.catch(error => {
				console.log(error)
			})
	}

	loadDataWali() {

		axios.post("/wali")
			.then(response => {

				return response.data.data.map(item => ({
					key: item.wali_id,
					value: item.user != null ? item.user.user_nama : '-' 
				}))
			})
			.then(result => {

				this.setState({
					dataWali: result
				})
			})
			.catch(error => {
				console.log(error)
			})
	}


	componentDidMount() {
		this.loadDataKelas()
		this.loadDataWali()
	}

	render() {   
		return (
			<div>
				<hr></hr>
				Form Data Siswa
				<hr></hr>
				&nbsp;

				<div className="form-group row">
					<label className="col-md-2 form-control-label">Kelas</label>
					<div className="col-md-10">
						<FormDropdown
							items={this.state.dataKelas}
							onChange={this.props.handleChange}
							value={this.props.parentState.kelas_id.toString()}
							name="kelas_id"
						/>
					</div>
				</div>

				<div className="form-group row">
					<label className="col-md-2 form-control-label">Wali</label>
					<div className="col-md-7">
						<FormDropdown
							items={this.state.dataWali}
							onChange={this.props.handleChange}
							value={this.props.parentState.wali_id}
							disabled={this.props.parentState.selectedWali === "buka"}
							name="wali_id"
						/>
					</div>
					<div className="col-md-3">
						<FormDropdown
							items={selectForm}
							onChange={this.props.handleChange}
							disabled={this.props.mode === "Edit"}
							value={this.props.parentState.selectedWali}
							name="selectedWali"/>
					</div>
				</div>

				<div className="form-group row">
					<label className="col-md-2 form-control-label">Nama Lengkap Siswa</label>
					<div className="col-md-10">
						<input
							name="siswa_nama"
							type="text"
							className="form-control"
							placeholder="Nama Lengkap"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_nama} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">NISN</label>
					<div className="col-md-10">
						<input
							name="siswa_nisn"
							type="text"
							className="form-control"
							placeholder="NISN"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_nisn} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">
						No. Induk Siswa <br />
						<small className="text-muted">
							<table>
								<tr>
									<td style={{verticalAlign: "top"}}><i className="fa fa-info-circle"></i>{" "}</td>
									<td>Digunakan sebagai username dan password default siswa</td>
								</tr>
							</table>                        
						</small>
					</label>
					<div className="col-md-10">
						<input
							name="siswa_nis"
							type="text"
							className="form-control"
							placeholder="Nomor Induk Siswa"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_nis} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Tahun Angkatan</label>
					<div className="col-md-10">
						<input
							name="siswa_tahun"
							type="number"
							className="form-control"
							placeholder="Tahun Angkatan Siswa"
							onChange={this.props.handleChange}
							maxLength={4}
							value={this.props.parentState.siswa_tahun} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Alamat</label>
					<div className="col-md-10">
						<textarea
							name="siswa_alamat"
							className="form-control"
							placeholder="Alamat Lengkap"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_alamat} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Kota</label>
					<div className="col-md-10">
						<input
							name="siswa_kota"
							type="text"
							className="form-control"
							placeholder="Alamat Kota"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_kota} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Provinsi</label>
					<div className="col-md-10">
						<input
							name="siswa_provinsi"
							type="text"
							className="form-control"
							placeholder="Alamat Provinsi"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_provinsi} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">No. HP</label>
					<div className="col-md-10">
						<input
							name="siswa_nohp"
							type="number"
							className="form-control"
							placeholder="No. Handphone"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_nohp} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Jenis Kelamin</label>
					<div className="col-md-10">
						<FormDropdown
							name="siswa_gender"
							items={jekel}
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_gender} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Tempat Lahir</label>
					<div className="col-md-10">
						<input
							name="siswa_tempat_lahir"
							type="text"
							className="form-control"
							placeholder="Tempat Lahir"
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_tempat_lahir} />
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Tanggal Lahir</label>
					<div className="col-md-10">
						<DatePicker
							selected={this.props.parentState.siswa_tanggal_lahir_moment}
							onChange={(momentObj) => {
								this.props.handleChangeDatepicker(momentObj, "siswa_tanggal_lahir_moment", "siswa_tanggal_lahir")
							}}
							peekNextMonth
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
						/>
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">REF ID KARTU</label>

					{localStorage.SISMART_USER_USERNAME === 'root@master.com' ? (
						<div className="col-md-10">
							<input
								name="siswa_rfid"
								type="number"
								className="form-control"
								placeholder="Masukkan REF ID Kartu yang valid"
								onChange={this.props.handleChange}
								value={this.props.parentState.siswa_rfid} />
						</div>
					):(
						<div className="col-md-10">
							<input
								name="siswa_rfid"
								type="number"
								className="form-control"
								placeholder="Masukkan REF ID Kartu yang valid"
								onChange={this.props.handleChange}
								// disabled={this.props.mode === "Edit"}
								value={this.props.parentState.siswa_rfid} />
						</div>
					)}

				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">
						Username
					</label>
					<div className="col-md-10">
						<input 
							name="siswa_username"
							type="text"
							disabled={this.props.mode === "Edit"} 
							className="form-control" 
							placeholder="Username untuk login" 
							onChange={this.props.handleChange} 
							value={this.props.parentState.siswa_username} />                                
					</div>
				</div> 
				<div className="form-group row">
					<label className="col-md-2 form-control-label">
						Password
					</label>
					<div className="col-md-10">
						<input 
							name="siswa_password"
							type="password" 
							className="form-control" 
							placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
							onChange={this.props.handleChange} 
							value={this.props.parentState.siswa_password} />                                
					</div>
				</div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">Status Aktif</label>
					<div className="col-md-10">
						<FormDropdown
							name="siswa_status"
							items={status_aktif}
							onChange={this.props.handleChange}
							value={this.props.parentState.siswa_status} />
					</div>
				</div>
				{
					this.props.mode === "Edit" && 
						(
							<div className="form-group row">
								<label className="col-md-2 form-control-label">Foto Siswa</label>
								<div className="col-md-10">
									<img
										src={FOTO_SISWA_HOST + this.props.parentState.siswa_foto_exist}
										alt=""
										style={{ width: "300px" }} />
								</div>
							</div>
						)
				}                
				<div className="form-group row">
					<label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Siswa</label>
					<div className="col-md-12">
						<Dropzone
							onDrop={(e) => this.props.onDrop(e, "siswa_foto")}
							multiple={false}
							style={{
								width: "100%",
								height: "auto",
								border: "2px dashed #e9e9e9",
								padding: "20px 30px",
								color: "#888",
								cursor: "pointer",
								textAlign: "center",
								marginBottom: "15px"
							}}
						>
							Klik atau drop file disini untuk mengupload file
						</Dropzone>
	
						{
							this.props.parentState.siswa_foto !== "" &&
							<span>
								{this.props.parentState.siswa_foto.name} {" "}
								<button
									title="Hapus"
									className="btn btn-sm btn-danger"
									onClick={() => this.props.handleDeleteFile("siswa_foto")}
									type="button"
								>
									<i className="fa fa-remove"></i>
								</button>
							</span>
						}
					</div>
				</div>

				<hr></hr>
				Form Data Wali
				<hr></hr>
				&nbsp;

				<div className="form-group row">
					<label className="col-md-2 form-control-label">Wali</label>
					<div className="col-md-7">
						<FormDropdown
							items={this.state.dataWali}
							onChange={this.props.handleChange}
							value={this.props.parentState.wali_id}
							disabled={this.props.parentState.selectedWali === "buka"}
							name="wali_id"
						/>
					</div>
					<div className="col-md-3">
						<FormDropdown
							items={selectForm}
							onChange={this.props.handleChange}
							disabled={this.props.mode === "Edit"}
							value={this.props.parentState.selectedWali}
							name="selectedWali"/>
					</div>
				</div>

				{
					this.props.parentState.selectedWali == "" || this.props.parentState.selectedWali == "tutup" ?"":
					
					<div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Nama Lengkap Wali</label>
							<div className="col-md-10">
								<input
									name="wali_nama"
									type="text"
									className="form-control"
									placeholder="Nama Lengkap"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_nama} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">
								No. HP <br />
								<small className="text-muted">
									<table>
										<tr>
											<td style={{ verticalAlign: "top" }}><i className="fa fa-info-circle"></i>{" "}</td>
											<td>Digunakan sebagai username dan password default wali</td>
										</tr>
									</table>
								</small>
							</label>
							<div className="col-md-10">
								<input
									name="wali_nohp"
									type="number"
									className="form-control"
									placeholder="No. Handphone"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_nohp} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Alamat</label>
							<div className="col-md-10">
								<textarea
									name="wali_alamat"
									className="form-control"
									placeholder="Alamat Lengkap"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_alamat} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Kota</label>
							<div className="col-md-10">
								<input
									name="wali_kota"
									type="text"
									className="form-control"
									placeholder="Alamat Kota"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_kota} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Provinsi</label>
							<div className="col-md-10">
								<input
									name="wali_provinsi"
									type="text"
									className="form-control"
									placeholder="Alamat Provinsi"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_provinsi} />
							</div>
						</div>                
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Jenis Kelamin</label>
							<div className="col-md-10">
								<FormDropdown
									name="wali_gender"
									items={jekel}
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_gender} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Tempat Lahir</label>
							<div className="col-md-10">
								<input
									name="wali_tempat_lahir"
									type="text"
									className="form-control"
									placeholder="Tempat Lahir"
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_tempat_lahir} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Tanggal Lahir</label>
							<div className="col-md-10">
								<DatePicker
									selected={this.props.parentState.wali_tanggal_lahir_moment}
									onChange={(momentObj) => {
										this.props.handleChangeDatepicker(momentObj, "wali_tanggal_lahir_moment", "wali_tanggal_lahir")
									}}
									peekNextMonth
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
								/>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">
								Username
							</label>
							<div className="col-md-10">
								<input 
									name="wali_username"
									type="text"
									className="form-control" 
									placeholder="Username untuk login" 
									onChange={this.props.handleChange} 
									value={this.props.parentState.wali_username} />                                
							</div>
						</div> 
						<div className="form-group row">
							<label className="col-md-2 form-control-label">
								Password
							</label>
							<div className="col-md-10">
								<input 
									name="wali_password"
									type="password"
									className="form-control" 
									placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
									onChange={this.props.handleChange} 
									value={this.props.parentState.wali_password} />                                
							</div>
						</div>
						<div className="form-group row">
							<label className="col-md-2 form-control-label">Status Aktif</label>
							<div className="col-md-10">
								<FormDropdown
									name="wali_status"
									items={status_aktif}
									onChange={this.props.handleChange}
									value={this.props.parentState.wali_status} />
							</div>
						</div>               
						{
							this.props.mode === "Edit" &&
							(
								<div className="form-group row">
									<label className="col-md-2 form-control-label">Foto Wali</label>
									<div className="col-md-10">
										<img
											src={FOTO_WALI_HOST + this.props.parentState.wali_foto_exist}
											alt=""
											style={{ width: "300px" }} />
									</div>
								</div>
							)
						} 
						<div className="form-group row">
							<label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Wali</label>
							<div className="col-md-12">
								<Dropzone
									onDrop={(e) => this.props.onDrop(e, "wali_foto")}
									multiple={false}
									style={{
										width: "100%",
										height: "auto",
										border: "2px dashed #e9e9e9",
										padding: "20px 30px",
										color: "#888",
										cursor: "pointer",
										textAlign: "center",
										marginBottom: "15px"
									}}
								>
									Klik atau drop file disini untuk mengupload file
								</Dropzone>
		
								{
									this.props.parentState.wali_foto !== "" &&
									<span>
										{this.props.parentState.wali_foto.name} {" "}
										<button
											title="Hapus"
											className="btn btn-sm btn-danger"
											onClick={() => this.props.handleDeleteFile("wali_foto")}
											type="button"
										>
											<i className="fa fa-remove"></i>
										</button>
									</span>
								}
							</div>
						</div>
					</div>
				}

			</div>
		)
	}
};

export default FormsSiswa;


// WEBPACK FOOTER //
// ./src/views/Users/FormsSiswa.js